import { AvatarDropdown as CoreAvatarDropdown, useSession } from '@zhiyue/core';
import { Avatar } from 'antd';
import { BizAppConfig } from 'config/application.manifest';
import React from 'react';
import styles from './index.module.less';

type HeaderUser = {
  realName?: string;
  name?: string;
  username?: string;
  nickname?: string;
  phone?: string;
  avatar?: string;
};

const getDisplayName = (user?: HeaderUser) =>
  user?.realName ||
  user?.name ||
  user?.username ||
  user?.nickname ||
  user?.phone ||
  '用户';

const AvatarDropdown: React.FC = () => {
  const { currentUser } = useSession();
  const user = currentUser as HeaderUser | undefined;
  const name = getDisplayName(user);
  const initial = name.trim().slice(0, 1) || '用';

  return (
    <div className={styles.root}>
      <CoreAvatarDropdown
        appId={BizAppConfig.appSsoClientId}
        personalCenterUrl={BizAppConfig.appPersonalCenterUrl}
        tenantManagementUrl={BizAppConfig.appTenantManagementUrl}
        workbenchUrl={BizAppConfig.appWorkbenchUrl}
        openPlatformUrl={''}
        feedbackUrl={''}
      >
        <span className={styles.trigger}>
          <Avatar size={22} src={user?.avatar} className={styles.avatar}>
            {initial}
          </Avatar>
          <span className={styles.name}>{name}</span>
        </span>
      </CoreAvatarDropdown>
    </div>
  );
};

export default AvatarDropdown;
